import React from 'react';
import OrdersList from '../controls/OrdersList.jsx';
import OrdersSearch from "../controls/OrdersSearch.jsx";

import AdminPageTypes from '../AdminPageTypes';
import Format from '../../utils/Formatter';

class BuscaPedido extends React.Component {

    render() {
        return (
            <OrdersSearch
                orders={this.props.expedicao.fechados}
                onSelectOrder={(orderId) => this.props.events.onSelectClosedOrder(orderId, this.props.token)}
                selectedOrder={this.props.expedicao.selecionada}
                idClienteName="idClienteExpedicao"
                idClienteExpedicao={this.props.expedicao.idClienteExpedicao}
                cpfClienteName="cpfClienteExpedicao"
                cpfClienteExpedicao={this.props.expedicao.cpfClienteExpedicao}
                showQrPreviewName="showQrPreviewExpedicao"
                showQrPreviewExpedicao={this.props.expedicao.showQrPreviewExpedicao}
                onUpdateValue={this.props.events.onUpdateText}
                onShowDialog={this.props.events.onShowDialog}
                onRefresh={() => this.props.events.onUpdateOrdersLists(this.props.token)}
            />
        );
    }
}

class Pedido extends React.Component {

    componentDidUpdate() {
        if (this.props.expedicao.selecionada) {
            $('#deliverButton').focus();
        }
    }

    render() {
        const selectedOrder = this.props.expedicao.selecionada;

        const onDeliverOrder = () => {
            let promise = this.props.events.onDeliverOrder(selectedOrder.id, this.props.token);
            if (this.props.app.adminPage === AdminPageTypes.CAIXA_EXPEDICAO) {
                promise = promise.then(() => this.props.events.onUpdateText('currentPage', AdminPageTypes.CAIXA));
            } else if (this.props.app.adminPage === AdminPageTypes.VENDA_CAIXA_EXPEDICAO) {
                promise = promise.then(() => this.props.events.onUpdateText('currentPage', AdminPageTypes.VENDA));
            }
        };

        const footer = (
            <button type="button" id="deliverButton" className="btn btn-primary m-b-5" onClick={onDeliverOrder}>
                <span className="glyphicon glyphicon-ok"></span> Finalizar Entrega
            </button>
        );
        const clientNameAppendix = selectedOrder ? " - " + selectedOrder.nome : "";

        return (
            <div className="panel panel-color panel-primary js-panel-resp">
                <div className="panel-heading">
                    <h3 className="panel-title">{"Pedido do cliente" + clientNameAppendix}</h3>
                </div>
                <div className="panel-body js-panel-body-w-footer">
                    <BuscaPedido {...this.props} />
                    {selectedOrder &&
                        <div className="form-group">
                            <label>Itens do pedido</label>
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                            <th>Valor</th>
                                            <th>Qtd</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedOrder.items.map(i => (
                                          <tr key={i.id_produto}>
                                              <td>{i.descricao}</td>
                                              <td>{Format.money(i.preco)}</td>
                                              <td>{i.quantidade}</td>
                                          </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                </div>
                {selectedOrder &&
                  <div className="panel-footer">
                      {footer}
                  </div>
                }
            </div>
        );
    }
}

class PedidosParaEntrega extends React.Component {

    render() {
        return (
            <OrdersList
                title={"Pedidos para entrega"}
                onRefresh={() => this.props.events.onUpdateOrdersLists(this.props.token)}
                orders={this.props.expedicao.fechados}
                cpf={this.props.expedicao.cpfClienteExpedicao}
                selectedOrder={this.props.expedicao.selecionada}
                onSelectOrder={(orderId) => this.props.events.onSelectClosedOrder(orderId, this.props.token)}
                noOrderText={"Nenhuma ordem para entrega"}
                badgeType={"bg-info"}
                badgeGlyph={"glyphicon glyphicon-print"}
                onClickBadge={(cartId) => this.props.events.onPrintOrder(cartId, this.props.token, 'delivery')}
                lastOrder={this.props.expedicao.lastOrder}
                onPrintLastOrder={() => this.props.events.onPrintOrder(this.props.expedicao.lastOrder.id, this.props.token, 'delivery')}
            />
        );
    }
}

class LojaExpedicao extends React.Component {

    render() {
        const adminPage = this.props.app.adminPage;
        const showClosedOrders = AdminPageTypes.CAIXA_EXPEDICAO !== adminPage && AdminPageTypes.VENDA_CAIXA_EXPEDICAO !== adminPage;

        return (
            <div className="wraper container-fluid">
                <div className="row">
                    <div className={showClosedOrders ? "col-lg-7" : "col-lg-12"}>
                        <Pedido {...this.props} />
                    </div>
                    {showClosedOrders &&
                        <div className="col-lg-5">
                            <PedidosParaEntrega {...this.props} />
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default LojaExpedicao;



// WEBPACK FOOTER //
// src/views/pages/LojaExpedicao.jsx